<template>
  <Fragment>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="时间和空间维度统计" name="first">
        <template v-if="$route.name !== 'timeAndAreaTj'">
          <router-view></router-view>
        </template>
        <section class="container" v-else>
          <Breadcrumb />
          <div class="card-wrap mt-20 mb-20">
            <section class="card-content">
              <div class="left">
                <div class="search-name mr-20">
                  <span>时间：</span>
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    placeholder="选择日期时间"
                    style="width:160px"
                    value-format=" yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
                <div class="search-name mr-20">
                  <span>至：</span>
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    placeholder="选择日期时间"
                    style="width:160px"
                    value-format=" yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
                <div class="search-name mr-20">
                  <span>省：</span>
                  <el-select
                    v-model="provinceId"
                    clearable
                    placeholder="请选择"
                    @change="getCityOptions(provinceId)"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.areaId"
                      :label="item.areaName"
                      :value="item.areaId"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="search-name mr-20">
                  <span>市：</span>
                  <el-select v-model="cityId" clearable placeholder="请选择">
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.areaId"
                      :label="item.areaName"
                      :value="item.areaId"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-button
                  type="primary"
                  class="ml-20"
                  @click="searchTimeAndAreaTJInfo"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  class="mr-20"
                  @click="exportTimeAndAreaTJ"
                  >下载</el-button
                >
              </div>
            </section>
          </div>
          <div class="card-wrap mt-20 mb-20">
            <span style="font-weight:bold">拍码总数：{{ sumNum }}</span>
          </div>
          <el-table :data="list" style="width: 150%" border>
            <el-table-column label="序号" width="200">
              <template slot-scope="scope">
                <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="时间" width="300">
              <template slot-scope="scope">
                <span>{{ scope.row.shootDate }}</span>
              </template>
            </el-table-column>
            <el-table-column label="省" width="300">
              <template slot-scope="scope">
                <span>{{ scope.row.provinceName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="市" width="300">
              <template slot-scope="scope">
                <span>{{ scope.row.cityName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="拍码数">
              <template slot-scope="scope">
                <span>{{ scope.row.number }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20 pagination"
            background
            layout="total,prev, pager, next, jumper"
            :total="total"
            :page-size="10"
            :current-page="pageNum"
            @prev-click="handlePrePage"
            @next-click="handleNextPage"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </section>
      </el-tab-pane>
      <el-tab-pane label="时间和空间维度统计图表" name="second">
        <div class="card-wrap mt-20 mb-40">
          <span
            style="font-size:25px;font-weight:bold;text-align: center;display:block;color: darkblue"
            >时间和空间维度统计表 拍码数：{{ sumNum }}
          </span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      provinceId: "",
      cityId: "",
      activeName: "first",
      sumNum: "",
      provinceOptions: [],
      cityOptions: [],
      areaId: "",
      areaName: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getTimeAndAreaTJList() {
      let _this = this;
      let param = {
        url: "/api/productNewTJTimeAndArea/getProductNewTjTimeAndAreaPage",
        params: {
          startDate: _this.startDate,
          endDate: _this.endDate,
          provinceId: _this.provinceId,
          cityId: _this.cityId,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getTimeAndAreaTJList", param).then(() => {
        _this.list = _this.$store.state.shootTJ.timeAndAreaTJList.list;
        _this.total = _this.$store.state.shootTJ.timeAndAreaTJList.total;
        if (_this.list.length > 0) {
          _this.sumNum = _this.list[0].sumNum;
        } else {
          _this.sumNum = 0;
        }
      });
    },
    //查询
    searchTimeAndAreaTJInfo() {
      let _this = this;
      _this.getTimeAndAreaTJList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getTimeAndAreaTJList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getTimeAndAreaTJList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getTimeAndAreaTJList();
    },
    //下载
    exportTimeAndAreaTJ() {
      let _this = this;
      let param = {
        startDate: _this.startDate,
        endDate: _this.endDate,
        provinceId: _this.provinceId,
        cityId: _this.cityId
      };
      _this.$Api
        .post(
          "/api/productNewTJTimeAndArea/exportProductNewTjTimeAndArea",
          param
        )
        .then(response => {
          if (response.status === 200) {
            _this.$Api.exportExcel(
              ["拍码总数", "时间", "省", "市", "拍码数"],
              ["sumNum", "shootDate", "provinceName", "cityName", "number"],
              response.data,
              "NewProducts_TimeAndAreaTj"
            );
          } else {
            _this.$message({
              message: "无法获取导出数据",
              type: "warning"
            });
          }
        });
    },
    //省下拉获取
    getProvinceOptions() {
      let _this = this;
      let param = {
        url: "/api/dictionaryArea/getDictionaryAreaList",
        params: {
          areaId: _this.areaId
        }
      };

      _this.$store.dispatch("getProvinceOptions", param).then(() => {
        _this.provinceOptions = _this.$store.state.area.provinceOptions;
      });
    },
    //根据省下拉获取对应的市
    getCityOptions(value) {
      let _this = this;
      let param = {
        url: "/api/dictionaryArea/getDictionaryAreaList",
        params: {
          areaId: value
        }
      };

      _this.$store.dispatch("getCityOptions", param).then(() => {
        _this.cityOptions = _this.$store.state.area.cityOptions;
      });
    }
  },
  created() {
    let _this = this;
    _this.getTimeAndAreaTJList();
    //省下拉框
    _this.getProvinceOptions();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
